import { Module } from '@nu-art/ts-common';
import { Dialog_DBExplorer } from '../ui/Dialog_DBExplorer/Dialog_DBExplorer.js';
class ModuleFE_DBExplorer_Class extends Module {
    keydownHandler = (e) => {
        if ((e.key === 'd' || e.key === 'D') && e.metaKey && e.shiftKey && e.altKey) {
            e.preventDefault();
            Dialog_DBExplorer.show();
        }
    };
    init() {
        super.init();
        document.addEventListener('keydown', this.keydownHandler);
    }
}
export const ModuleFE_DBExplorer = new ModuleFE_DBExplorer_Class();
//# sourceMappingURL=ModuleFE_DBExplorer.js.map